import { useState, useEffect } from "react";
import { FaEnvelope, FaPhone } from "react-icons/fa";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // handlesub
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    // Payload
    const payload = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    try {
          const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const res = await fetch(
        
       ` ${baseUrl}support_service`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
        setResponseMsg(
          "✅ Thank you for reaching out! We’ll get back to you soon."
        );
        setFormData({ name: "", email: "", message: "" });
      } else {
        setResponseMsg("❌ Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting contact form:", error);
      setResponseMsg("⚠️ Unable to connect. Please check your network.");
    }

    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto mt-16 px-4 sm:px-6 mt-28">
      <div className="text-center mb-6 sm:mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#353535]">
          Reach Out to Our <span className="text-[#ca8032]">Support Team</span>
        </h1>
        <p className="text-gray-600 text-sm sm:text-base mt-2 px-2 sm:px-0">
          Reach out and let us help you with bookings, policies, or any other
          queries.
        </p>
      </div>


      {/* Contact Info */}
      <div className="bg-white rounded-xl shadow py-4 px-4 sm:px-6 mb-4 flex flex-col sm:flex-row justify-center items-start sm:items-center gap-4 sm:gap-8 text-gray-700 text-sm sm:text-base">
        <div className="flex items-center gap-2">
          <FaEnvelope className="text-[#ca8032]" />
          <span className="break-words">
            <strong>EMAIL:</strong> care@aombre.com
          </span>
        </div>
        <div className="flex items-center gap-2">
          <FaPhone className="text-[#ca8032]" />
          <span className="break-words">
            <strong>PHONE:</strong> +1 (888) 980-4410
          </span>
        </div>
      </div>

      {/* Contact Form */}
      <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 mb-8">
        <form className="flex flex-col gap-4 sm:gap-6" onSubmit={handleSubmit}>
          <div>
            <label className="block text-gray-700 font-semibold mb-1 sm:mb-2">
              Name*
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your name"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:outline-none focus:ring-2 focus:ring-[#ca8032]"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1 sm:mb-2">
              Email address*
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:outline-none focus:ring-2 focus:ring-[#ca8032]"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1 sm:mb-2">
              Your Message*
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your message"
              rows="5"
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 sm:px-4 sm:py-2 focus:outline-none focus:ring-2 focus:ring-[#ca8032]"
            ></textarea>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="bg-[#ca8032] hover:bg-[#b06f2c] text-white font-semibold rounded-lg py-3 transition mt-2 disabled:opacity-60"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>

        {responseMsg && (
          <p className="mt-4 text-center text-sm font-medium text-gray-700">
            {responseMsg}
          </p>
        )}
      </div>
    </div>
  );
}

export default ContactUs;
